import officialscoresheetStyles from '../../officialscoresheet.module.css';
import ToastStack from '../../toaststack';

const { toastFooter: footerClass } = officialscoresheetStyles;

export function Footer({ hide }) {
  return !hide ? (
    <div className={footerClass}>
      <ToastStack />
    </div>
  ) : null;
}
